import React, { Component, useContext } from "react";
import { useHistory, Link, NavLink } from "react-router-dom";
import TaskQueueView from "../../../Components/Admin/TaskQueue/View";

function TaskQueueIndex(props) {
  const history = useHistory();
  return (
    <React.Fragment>
      <div className="container-fluid">
        <h2>Queue Details</h2>
        <hr />
        <TaskQueueView />
      </div>
    </React.Fragment>
  );
}

export default TaskQueueIndex;
